import Close from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/Content/Close";

type Props = { onClose: () => void; hiddenCloseBtn?: boolean };

const Content: FC<Props> = ({ onClose, hiddenCloseBtn, children }) => (
  <div className="relative grid w-[stretch] gap-4 rounded-lg bg-white px-8 pb-8 text-center shadow-xl md:w-80 overflow-hidden">
    {!hiddenCloseBtn && <Close onClose={onClose} />}
    {children}
  </div>
);

export default Content;
